module.exports = __webpack_public_path__ + "static/media/ic-instagram.ee1a89e4.svg";